// extracted by mini-css-extract-plugin
module.exports = {"Box":"styles_Box__2L3tw"};